import React from 'react'
import {Tooltip} from "@material-ui/core";
import zIndex from './zIndex';

const CustomTooltip = ({ children, title = '' }) =>
  <Tooltip title={title} PopperProps={{ style: { zIndex: zIndex(1) } }}>{children}</Tooltip>

export default CustomTooltip